import { Box, CircularProgress } from "@mui/material";
import logo from "../images/willsoar.svg";

const SplashScreen = () => {
  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="#fff"
    >
      <img src={logo} alt="App Logo" height={80} />
      <CircularProgress sx={{ mt: 4,color:"#fe6a2c" }} />
    </Box>
  );
};

export default SplashScreen;
